import { render, staticRenderFns } from "./sidebar-panel.vue?vue&type=template&id=0d443a3d&scoped=true&lang=pug&"
import script from "./sidebar-panel.vue?vue&type=script&lang=coffee&"
export * from "./sidebar-panel.vue?vue&type=script&lang=coffee&"
import style0 from "./sidebar-panel.vue?vue&type=style&index=0&id=0d443a3d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d443a3d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterableListSidebarHeader: require('/opt/build/repo/library/components/globals/filterable-list/sidebar-header.vue').default})
